import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import { FETCH_BOOKINGS_DATA, FETCH_BOOKINGS_DETAILS_DATA } from "./actionTypes";
import {
  fetchBookingsSuccess,
  fetchBookingsFailure,
  fetchBookingsDetailsSuccess,
  fetchBookingsDetailsFailure
} from "./actions";

function* fetchBookingsDataSaga(action) {
  try {
    const { page = 1, limit = 10, driverId, search } = action.payload || {};
    const params = new URLSearchParams();
    params.set("page", String(page));
    params.set("limit", String(limit));
    if (driverId) params.set("driverId", String(driverId));
    if (search) params.set("search", search);
    const url = process.env.REACT_APP_WEB_APP_URL + `/api/web/bookings?${params.toString()}`;
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const payload = response.data;
    // Backward compatibility: if API doesn't return total, use current page length
    if (payload.total == null && Array.isArray(payload.data)) {
      payload.total = payload.data.length;
    }
    yield put(fetchBookingsSuccess(payload));
  } catch (error) {
    yield put(fetchBookingsFailure(error.message));
  }
}

function* fetchBookingsDetailsDataSaga(action) {
  try {
    const id = action.payload;
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, process.env.REACT_APP_WEB_APP_URL + `/api/web/bookings/${id}`,{
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
    yield put(fetchBookingsDetailsSuccess(response.data));
  } catch (error) {
    yield put(fetchBookingsDetailsFailure(error.message));
  }
}

export default function* bookingsSaga() {
  yield takeEvery(FETCH_BOOKINGS_DATA, fetchBookingsDataSaga);
  yield takeEvery(FETCH_BOOKINGS_DETAILS_DATA, fetchBookingsDetailsDataSaga); 
}
